import type React from 'react';
import { Outlet, useMatches } from 'react-router-dom';
import CheckoutHeader from '@/shared/features/header/presentation/components/CheckoutHeader';
import CheckoutFooter from '@/shared/features/footer/presentation/components/CheckoutFooter';
import { cn } from '@/shared/utils/cn';

interface CheckoutFlowLayoutProps {
  children?: React.ReactNode;
  className?: string;
  contentClassName?: string;
  footerClassName?: string;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  showHeader?: boolean;
  showFooter?: boolean;
}

type CheckoutFlowRouteOptions = Pick<
  CheckoutFlowLayoutProps,
  'className' | 'contentClassName' | 'footerClassName' | 'showHeader' | 'showFooter'
>;

interface CheckoutFlowRouteHandle {
  checkoutLayout?: false | CheckoutFlowRouteOptions;
}

export function CheckoutFlowLayout({
  children,
  className,
  contentClassName,
  footerClassName,
  header,
  footer,
  showHeader = true,
  showFooter = true,
}: CheckoutFlowLayoutProps) {
  return (
    <div className={cn('pay-via-link-page flex min-h-screen flex-col bg-white', className)}>
      <div className={cn('flex flex-1 flex-col', contentClassName)}>
        {showHeader && (header || <CheckoutHeader />)}
        {children || <Outlet />}
      </div>

      {showFooter && (footer || <CheckoutFooter className={cn('mt-0', footerClassName)} />)}
    </div>
  );
}

export function CheckoutFlowRouteLayout() {
  const matches = useMatches();
  const activeCheckoutMatch = [...matches]
    .reverse()
    .find((match) => (match.handle as CheckoutFlowRouteHandle | undefined)?.checkoutLayout !== undefined);
  const checkoutLayout = (activeCheckoutMatch?.handle as CheckoutFlowRouteHandle | undefined)?.checkoutLayout;

  if (checkoutLayout === false) {
    return <Outlet />;
  }

  return <CheckoutFlowLayout {...checkoutLayout} />;
}

export default CheckoutFlowRouteLayout;
